import * as types from "./actionTypes";
import * as profileApi from "../../_api/profileApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";
import { logGeneralException } from "../../_api/generalExceptionApi";

export function loadProfileSuccess(profile) {
  return { type: types.LOAD_PROFILE_SUCCESS, profile };
}

export function saveProfileSuccess(profile) {
  return { type: types.SAVE_PROFILE_SUCCESS, profile };
}

export function updateOrCopyClientProfileSuccess(profile) {
  return { type: types.UPDATE_COPY_PROFILE_SUCCESS, profile };
}

export function loadProfile(ClientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return profileApi
      .getProfile(ClientId)
      .then((profile) => {
        dispatch(loadProfileSuccess(profile));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveProfile(ClientId, params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return profileApi
      .updateProfile(ClientId, params)
      .then((profile) => {
        dispatch(saveProfileSuccess(profile));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        // Log exception to api
        logGeneralException({
          portalId: 2,
          description: "User Update Error: " + error,
          source: "Client Portal Front",
          fileName: "profileActions.jsx",
          functionName: "saveProfile",
          notes: "Error with Updating User.",
          addBy: params.userId,
          clientID: ClientId,
        });
        throw error;
      });
  };
}

export function updateOrCopyClientProfile(ClientId, params) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return profileApi
      .updateOrCopyClientProfile(params)
      .then((profile) => {
        dispatch(updateOrCopyClientProfileSuccess(profile));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        // Log exception to api
        logGeneralException({
          portalId: 2,
          description: "User Update Error: " + error,
          source: "Client Portal Front",
          fileName: "profileActions.jsx",
          functionName: "updateOrCopyClientProfile",
          notes: "Error with Updating User.",
          addBy: params.userId,
          clientID: ClientId,
        });
        throw error;
      });
  };
}
